import React from "react";

import { Box, Grid, Skeleton as MUISkeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SUMMARY_CHART_HEIGHT } from "..";
import ChartWrapper from "../Wrapper";

interface IProps {
  currencyPairs: string[];
}

const ChartSkeleton: React.FC = () => (
  <MUISkeleton variant="rectangular" width="100%" height={SUMMARY_CHART_HEIGHT} sx={{ borderRadius: "10px" }} />
);

const Skeleton: React.FC<IProps> = ({ currencyPairs }) => {
  const { t } = useTranslation<string>();

  const baseCurrencies = [...new Set(currencyPairs.map((cp) => cp.split("/")[0]))];
  const singleCurrency = baseCurrencies.length === 1;

  return (
    <>
      <Grid container spacing={2}>
        {baseCurrencies.map((currency) => (
          <Grid item xs={12} lg={singleCurrency ? 12 : 6} key={`skeleton-amount-${currency}`}>
            <ChartWrapper title={t("summaries.charts.amountChart", { currency })} loading>
              <ChartSkeleton />
            </ChartWrapper>
          </Grid>
        ))}
      </Grid>
      <Box mt={2}>
        <Grid container spacing={2}>
          {currencyPairs.map((pair) => (
            <React.Fragment key={`skeleton-pair-${pair}`}>
              <Grid item xs={12} lg={6}>
                <ChartWrapper title={t("summaries.charts.investmentChart", { currency: pair })} loading>
                  <ChartSkeleton />
                </ChartWrapper>
              </Grid>
              <Grid item xs={12} lg={6}>
                <ChartWrapper title={t("summaries.charts.priceChart", { currency: pair })} loading>
                  <ChartSkeleton />
                </ChartWrapper>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Skeleton;
